import type {
  DeckDetail,
  DeckSummary,
  TrainingMaterialDetail,
  TrainingMaterialSummary,
} from '@creativitas/shared';
import { apiFetch } from '@/lib/api';

/** Read-only content endpoints. Access verdicts arrive with every item (§19). */

export const DECKS_KEY = ['decks'] as const;
export const TRAINING_KEY = ['training'] as const;

export const fetchDecks = (options: { freeformOnly?: boolean } = {}): Promise<{
  items: DeckSummary[];
}> =>
  apiFetch<{ items: DeckSummary[] }>(
    options.freeformOnly ? '/decks?freeform=true' : '/decks',
  );

export const fetchDeck = (deckId: string): Promise<DeckDetail> =>
  apiFetch<DeckDetail>(`/decks/${deckId}`);

export const fetchTrainingMaterials = (): Promise<{ items: TrainingMaterialSummary[] }> =>
  apiFetch<{ items: TrainingMaterialSummary[] }>('/training');

export const fetchTrainingMaterial = (id: string): Promise<TrainingMaterialDetail> =>
  apiFetch<TrainingMaterialDetail>(`/training/${id}`);
